module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAF3RSTlMAVaqAf/g160fl2k478OC8cUAsEYhmJFoE8OsAAABuSURBVEjH7dNREkAgGEXhCFFRCv/+d2ragfPQDJP7/J3Hqz64GM5MfC8iDnqJ0MsFfcf8SL2r7Gfm18reUL8zv1Dv6/ptquZD8fa5t9D74k0CjxxLMYDgEFp0jRf6L5orJlpoRQojkhRZ1urtuwHGnhJXZk1pHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resource/back_ffffff.png
// module id = mThV
// module chunks = 1